<!-- <dash-page-header title="Collection "></dash-page-header> -->
<div class="page-title">{{collectionName}}</div>

<div *ngIf="collectionName" class="bottom">
  <a class="btn primary-btn" (click)="openEmailApplication($event)">
    <i class="fa fa-share" aria-hidden="true"></i>
    Share
  </a>
  <div>
    <button type="button" class="btn primary-btn dropdown-toggle ml-3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <i class="fa fa-ellipsis-h"></i></button>
    <ul class="dropdown-menu dropdown-main">
      <li> <a (click)="showRenameCollection()"> <i aria-hidden="true"></i> Rename Collection</a> </li>
      <li> <a (click)="showDeleteCollection()"> <i aria-hidden="true"></i> Delete Collection</a> </li>
    </ul>
  </div>
</div>

<h4>{{ totalRecords }} Job(s)</h4>
<div class="saved-table m-bottom-2">
  <div styleclass="no-fixed-table" [loadingIndicator]="loadingSubscription">
    <p-table
      [value]="jobs"
      [columns]="cols"
      [lazy]="true"
      [paginator]="true"
      (onLazyLoad)="getPage($event)"
      [rows]="rowsPerPage"
      [totalRecords]="totalRecords"
             sortmode="single" [sortField]="sortField">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="width: 24px;"></th>
          <th *ngFor="let col of columns" [style.width]="col.width" [pSortableColumn]="col.field">
            {{col.header}}

            <more-info-tooltip *ngIf="col.field === 'actualDate|projectedDate'">
              <i icon class="fa fa-info-circle"></i>
              <div message style="width: 150px">
                Projected Date is Editable<br/>
                Actual Date is Not Editable
              </div>
            </more-info-tooltip>

            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
          <th style="width: 40px;"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-jobForm let-columns="columns">
        <tr>
          <td>
            <job-list-status-icons [jobForm]="jobForm"></job-list-status-icons>
          </td>
          <td>
            <a [routerLink]="['/job-simple', jobForm.job.id]">{{jobForm.job.jobCode}}</a>
          </td>
           <td [ngClass]="{ 'risk-level-background': jobForm.job.riskLevel > 3 }">
            {{jobForm.job.riskLevel}}
          </td>
          <td>
            {{jobForm.job.customerName}}
          </td>
          <td>
            <a class="show-underline" (click)="openEditWell($event, jobForm.job.wellId)">{{jobForm.job.wellName}}</a>
          </td>
          <td>
            {{jobForm.job.wellNumber}}
          </td>
          <td>
            {{jobForm.job.rigName}}
          </td>
          <td>
            {{jobForm.job.jobName}}
          </td>
          <td>
            {{jobForm.job.jobTypeName}}
          </td>
          <td class="vertical-align-middle">
            <control-point-statuses [jobForm]="jobForm"></control-point-statuses>
          </td>
          <td>
            {{jobForm.job.jobStatusDescription}}
          </td>
          <td>
            <job-date [jobForm]="jobForm"> </job-date>
          </td>
          <td class="vertical-align-middle">
            <div *ngIf="jobForm.job.cmtSvc"
                 class="appian-status" [ngClass]="{'partially-pushed': jobForm.job.appianPushState === 2,
                                                   'fully-pushed': jobForm.job.appianPushState === 3}">
            </div>
          </td>
          <td class="vertical-align-middle">
            <div *ngIf="jobForm.job.cmtSvc" class="appian-status" openBulkBoard [ngClass]="{'partially-loaded': jobForm.job.appianBBLoadStatus === 1,
                                                                              'fully-loaded': jobForm.job.appianBBLoadStatus === 2}">
            </div>
          </td>
          <td>
            {{jobForm.job.modifiedDate  | dateFormatWithLocalTimeZone: DATE_TIME_CALL_STANDARD }}
          </td>
          <td>
            <span style="display:flex; flex-direction: row;justify-content: space-between;" class="ng-star-inserted">
              <div class="dropdown">
                <button (click)="showAllCollectionNameManagement(jobForm.job.id)" class="btn-link" type="button" data-toggle="dropdown">
                  <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                </button>
                <ul class="dropdown-menu show-left">
                  <li>
                    <a [routerLink]="['/job-simple', jobForm.job.id]">
                      <i class="fa fa-th-large" aria-hidden="true"></i> Go to Dashboard</a>
                  </li>
                  <li *ngIf="collectionNameManagement?.length > 0" [ngClass]="{'has-submenu' : collectionNameManagement?.length > 0}">
                    <a>
                      <i class="fa fa-plus" aria-hidden="true"></i> Add to Collection </a>
                    <ul class="dropdown-menu">
                      <li *ngFor="let col of collectionNameManagement">
                        <a (click)="addToCollectionManagement(col.key, jobForm.job.id, col.value)" title="{{col.value}}">{{col.value}}</a>
                      </li>
                    </ul>
                  </li>
                  <li *ngIf="removeCollectionNameManagement?.length > 0" [ngClass]="{'has-submenu' : removeCollectionNameManagement?.length > 0}">
                    <a>
                      <i class="fa fa-times" aria-hidden="true"></i> Remove from Collection </a>
                    <ul class="dropdown-menu">
                      <li *ngFor="let col of removeCollectionNameManagement">
                        <a (click)="removeFromCollectionManagement(col.key, jobForm.job.id, col.value)" title="{{col.value}}">{{col.value}}</a>
                      </li>
                    </ul>
                  </li>
                  <li *ngIf="jobForm.job.canChangeJobOwner">
                    <a (click)="changeJobOwner(jobForm.job.id, jobForm.job.jobOwner)">
                      <img src="../../../assets/images/person_search_black_24dp.svg"> Change Job Owner </a>
                  </li>
                </ul>
              </div>
            </span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length + 2">
            No records found
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<!-- Rename Collection-->
<p-dialog header="Rename Collection" [(visible)]="isShowRenameCollection" [draggable]="false" modal="true" styleClass="dialog-custom"
           [style]=" {width: '385px', height: '200px'}" [baseZIndex]="10000" (onHide)="messageError = ''" (onShow)="onShow()">
  <form [formGroup]="collectionEdit" class="dialog-message">
    <div class="w-100">
      <input type="text" class="form-control" formControlName="collectionName">
      <error-display formControlName="collectionName" [errorMsg]="errorMessages.collectionName"></error-display>
      <div *ngIf="messageError" class="text-error-message">{{messageError}}</div>
    </div>
    <div *ngIf="messageError" class="text-error-message">{{messageError}}</div>
  </form>
  <div class="dialog-footer">
    <button class="btn primary-btn" [disabled]="isDisable" #divClick (click)="renameCollection()">Save</button>
  </div>

</p-dialog>

<change-job-owner-dialog></change-job-owner-dialog>
